<div
  class="flex h-10 flex-shrink-0 items-center justify-between px-5 pt-5 pb-0"
>
  <div class="flex items-center">
    <div
      class="truncate text-base leading-normal font-normal text-primary-text"
    >
      {{
        'common.filter.entities.selectedAmount'
          | translate: { amount: selectedCount() }
      }}
    </div>
  </div>
  <button
    class="text-base leading-normal font-normal"
    [class.text-orange-500]="selectedCount()"
    [class.font-medium]="selectedCount()"
    [class.text-neutral-300]="!selectedCount()"
    [disabled]="!selectedCount()"
    (click)="clearSelection.emit()"
  >
    {{ 'common.filter.entities.clearSelection' | translate }}
  </button>
</div>
